/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  Upload: any;
};

export type AssetClass = {
  __typename?: 'AssetClass';
  chartColors: Array<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Autogenerated input type of CreateDocument */
export type CreateDocumentInput = {
  author: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  internal: Scalars['Boolean'];
  name: Scalars['String'];
  onboardingId: Scalars['String'];
};

/** Autogenerated return type of CreateDocument. */
export type CreateDocumentPayload = {
  __typename?: 'CreateDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  document: Document;
};

export type Depot = {
  __typename?: 'Depot';
  clearingIban?: Maybe<Scalars['String']>;
  depotNumber?: Maybe<Scalars['String']>;
  historicalDepotValues: Array<HistoricalDepotValue>;
  /** @deprecated Use `clearing_iban` instead. */
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  monthlySummaries: MonthlySummaryConnection;
  monthlySummary: MonthlySummary;
  netInvestmentSinceInception?: Maybe<Scalars['Float']>;
  netInvestmentSinceInceptionDeposits?: Maybe<Scalars['Float']>;
  netInvestmentSinceInceptionWithdrawals?: Maybe<Scalars['Float']>;
  onboardingId: Scalars['String'];
  pendingDeposit: PendingTransaction;
  pendingDeposits: PendingTransactionConnection;
  pendingTransaction: PendingTransaction;
  pendingTransactions: PendingTransactionConnection;
  portfolioBreakdown: Array<PortfolioBreakdown>;
  referenceIban?: Maybe<Scalars['String']>;
  strategy?: Maybe<Scalars['String']>;
  transactions: TransactionConnection;
  twr1yAbs?: Maybe<Scalars['Float']>;
  twr1yRel?: Maybe<Scalars['Float']>;
  twrSinceInceptionAbs: Scalars['Float'];
  twrSinceInceptionRel: Scalars['Float'];
  twrYtdAbs?: Maybe<Scalars['Float']>;
  twrYtdRel?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};


export type DepotMonthlySummariesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DepotMonthlySummaryArgs = {
  id: Scalars['ID'];
};


export type DepotPendingDepositArgs = {
  id: Scalars['ID'];
};


export type DepotPendingDepositsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DepotPendingTransactionArgs = {
  id: Scalars['ID'];
};


export type DepotPendingTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DepotTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<TransactionTransaction>>;
};

export type Document = {
  __typename?: 'Document';
  author?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  depot?: Maybe<Depot>;
  depotId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  internal: Scalars['Boolean'];
  name: Scalars['String'];
  onboardingId: Scalars['String'];
  read: Scalars['Boolean'];
  untrackedUrl: Scalars['String'];
  url: Scalars['String'];
};

/** The connection type for Document. */
export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  /** A list of edges. */
  edges: Array<DocumentEdge>;
  /** A list of nodes. */
  nodes: Array<Document>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Document>;
};

export type HistoricalDepotValue = {
  __typename?: 'HistoricalDepotValue';
  calendarDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  twr1yAbs?: Maybe<Scalars['Float']>;
  twr1yRel?: Maybe<Scalars['Float']>;
  twrRelPerc: Scalars['Float'];
  twrSinceInceptionAbs?: Maybe<Scalars['Float']>;
  twrSinceInceptionRel?: Maybe<Scalars['Float']>;
  twrYtdAbs?: Maybe<Scalars['Float']>;
  twrYtdRel?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

export type MonthlySummary = {
  __typename?: 'MonthlySummary';
  amount: Scalars['Float'];
  breakdowns: MonthlySummaryBreakdownConnection;
  id: Scalars['ID'];
  month: Scalars['ISO8601Date'];
  transactions: TransactionConnection;
};


export type MonthlySummaryBreakdownsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MonthlySummaryTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MonthlySummaryBreakdown = {
  __typename?: 'MonthlySummaryBreakdown';
  assetClass: AssetClass;
  assetClassId: Scalars['ID'];
  id: Scalars['ID'];
  percentage: Scalars['Float'];
};

/** The connection type for MonthlySummaryBreakdown. */
export type MonthlySummaryBreakdownConnection = {
  __typename?: 'MonthlySummaryBreakdownConnection';
  /** A list of edges. */
  edges: Array<MonthlySummaryBreakdownEdge>;
  /** A list of nodes. */
  nodes: Array<MonthlySummaryBreakdown>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MonthlySummaryBreakdownEdge = {
  __typename?: 'MonthlySummaryBreakdownEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MonthlySummaryBreakdown>;
};

/** The connection type for MonthlySummary. */
export type MonthlySummaryConnection = {
  __typename?: 'MonthlySummaryConnection';
  /** A list of edges. */
  edges: Array<MonthlySummaryEdge>;
  /** A list of nodes. */
  nodes: Array<MonthlySummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MonthlySummaryEdge = {
  __typename?: 'MonthlySummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MonthlySummary>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createDocument?: Maybe<CreateDocumentPayload>;
  requestDeposit?: Maybe<RequestDepositPayload>;
  requestWithdrawal?: Maybe<RequestWithdrawalPayload>;
};


export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationRequestDepositArgs = {
  input: RequestDepositInput;
};


export type MutationRequestWithdrawalArgs = {
  input: RequestWithdrawalInput;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PendingTransaction = {
  __typename?: 'PendingTransaction';
  createdAt: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  transactionType: PendingTransactionTransaction;
  value: Scalars['Float'];
};

/** The connection type for PendingTransaction. */
export type PendingTransactionConnection = {
  __typename?: 'PendingTransactionConnection';
  /** A list of edges. */
  edges: Array<PendingTransactionEdge>;
  /** A list of nodes. */
  nodes: Array<PendingTransaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PendingTransactionEdge = {
  __typename?: 'PendingTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PendingTransaction>;
};

export enum PendingTransactionTransaction {
  /** Deposit */
  Deposit = 'deposit',
  /** Withdrawal */
  Withdrawal = 'withdrawal'
}

export type PortfolioAsset = {
  __typename?: 'PortfolioAsset';
  assetClass: AssetClass;
  assetClassId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
};

/** The connection type for PortfolioAsset. */
export type PortfolioAssetConnection = {
  __typename?: 'PortfolioAssetConnection';
  /** A list of edges. */
  edges: Array<PortfolioAssetEdge>;
  /** A list of nodes. */
  nodes: Array<PortfolioAsset>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PortfolioAssetEdge = {
  __typename?: 'PortfolioAssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PortfolioAsset>;
};

export type PortfolioBreakdown = {
  __typename?: 'PortfolioBreakdown';
  assetClass: AssetClass;
  assetClassId: Scalars['ID'];
  assets: PortfolioAssetConnection;
  id: Scalars['ID'];
  percentage: Scalars['Float'];
};


export type PortfolioBreakdownAssetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  /** Info about the currently logged in user's depot */
  depot?: Maybe<Depot>;
  /** Documents of the current user, ordered by newest first */
  documents: DocumentConnection;
  /** Info about the currently logged in user */
  viewer: Viewer;
};


export type QueryDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onboardingIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of RequestDeposit */
export type RequestDepositInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  value: Scalars['Float'];
};

/** Autogenerated return type of RequestDeposit. */
export type RequestDepositPayload = {
  __typename?: 'RequestDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deposit: PendingTransaction;
  depot: Depot;
};

/** Autogenerated input type of RequestWithdrawal */
export type RequestWithdrawalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  value: Scalars['Float'];
};

/** Autogenerated return type of RequestWithdrawal. */
export type RequestWithdrawalPayload = {
  __typename?: 'RequestWithdrawalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  depot: Depot;
  withdrawal: PendingTransaction;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Float'];
  description: Scalars['String'];
  happenedOn: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  transactionType: TransactionTransaction;
};

/** The connection type for Transaction. */
export type TransactionConnection = {
  __typename?: 'TransactionConnection';
  /** A list of edges. */
  edges: Array<TransactionEdge>;
  /** A list of nodes. */
  nodes: Array<Transaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TransactionEdge = {
  __typename?: 'TransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Transaction>;
};

export enum TransactionTransaction {
  /** Credit */
  Credit = 'credit',
  /** Deposit */
  Deposit = 'deposit',
  /** Fee */
  Fee = 'fee',
  /** Other */
  Other = 'other',
  /** Payout */
  Payout = 'payout',
  /** Purchase */
  Purchase = 'purchase',
  /** Sell */
  Sell = 'sell',
  /** Withdrawal */
  Withdrawal = 'withdrawal'
}

export type Viewer = {
  __typename?: 'Viewer';
  email: Scalars['String'];
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GetNavbarDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNavbarDataQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', name: string } };

export type GetHomeDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomeDataQuery = { __typename?: 'Query', depot?: { __typename?: 'Depot', id: string, value: number, twrSinceInceptionAbs: number, twrSinceInceptionRel: number, twrYtdAbs?: number | null, twrYtdRel?: number | null, twr1yAbs?: number | null, twr1yRel?: number | null, netInvestmentSinceInception?: number | null, clearingIban?: string | null, historicalDepotValues: Array<{ __typename?: 'HistoricalDepotValue', id: string, value: number, calendarDate: any, twrRelPerc: number, twr1yAbs?: number | null, twr1yRel?: number | null, twrSinceInceptionAbs?: number | null, twrSinceInceptionRel?: number | null, twrYtdAbs?: number | null, twrYtdRel?: number | null }> } | null };

export type GetMonthlyDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMonthlyDetailsQuery = { __typename?: 'Query', depot?: { __typename?: 'Depot', id: string, monthlySummary: { __typename?: 'MonthlySummary', transactions: { __typename?: 'TransactionConnection', nodes: Array<{ __typename?: 'Transaction', id: string, happenedOn: any, transactionType: TransactionTransaction, description: string, amount: number }> } } } | null };

export type GetPortfolioDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPortfolioDataQuery = { __typename?: 'Query', depot?: { __typename?: 'Depot', portfolioBreakdown: Array<{ __typename?: 'PortfolioBreakdown', id: string, percentage: number, assets: { __typename?: 'PortfolioAssetConnection', nodes: Array<{ __typename?: 'PortfolioAsset', id: string, name: string, percentage: number }> }, assetClass: { __typename?: 'AssetClass', id: string, name: string, chartColors: Array<string> } }> } | null };

export type GetDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', nodes: Array<{ __typename?: 'Document', id: string, author?: string | null, createdAt: any, name: string, read: boolean, url: string }> } };

export type GetProfileDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileDataQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', email: string, givenName?: string | null, familyName?: string | null, name: string }, depot?: { __typename?: 'Depot', id: string, clearingIban?: string | null, strategy?: string | null, depotNumber?: string | null, value: number } | null };

export type GetTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransactionsQuery = { __typename?: 'Query', depot?: { __typename?: 'Depot', id: string, monthlySummaries: { __typename?: 'MonthlySummaryConnection', nodes: Array<{ __typename?: 'MonthlySummary', id: string, amount: number, month: any, transactions: { __typename?: 'TransactionConnection', nodes: Array<{ __typename?: 'Transaction', id: string }> }, breakdowns: { __typename?: 'MonthlySummaryBreakdownConnection', nodes: Array<{ __typename?: 'MonthlySummaryBreakdown', id: string, percentage: number, assetClass: { __typename?: 'AssetClass', id: string, name: string, chartColors: Array<string> } }> } }> }, pendingTransactions: { __typename?: 'PendingTransactionConnection', nodes: Array<{ __typename?: 'PendingTransaction', id: string, createdAt: any, value: number, transactionType: PendingTransactionTransaction }> }, transactions: { __typename?: 'TransactionConnection', nodes: Array<{ __typename?: 'Transaction', id: string, happenedOn: any, transactionType: TransactionTransaction, description: string, amount: number }> } } | null };

export type RequestDepositMutationVariables = Exact<{
  id: Scalars['ID'];
  value: Scalars['Float'];
}>;


export type RequestDepositMutation = { __typename?: 'Mutation', requestDeposit?: { __typename?: 'RequestDepositPayload', depot: { __typename?: 'Depot', id: string, pendingDeposits: { __typename?: 'PendingTransactionConnection', nodes: Array<{ __typename?: 'PendingTransaction', id: string, value: number, createdAt: any }> } } } | null };

export type GetDepotQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepotQuery = { __typename?: 'Query', depot?: { __typename?: 'Depot', id: string, value: number, clearingIban?: string | null, strategy?: string | null, depotNumber?: string | null, twrSinceInceptionAbs: number, twrSinceInceptionRel: number, twr1yAbs?: number | null, twr1yRel?: number | null, twrYtdAbs?: number | null, twrYtdRel?: number | null, netInvestmentSinceInception?: number | null, historicalDepotValues: Array<{ __typename?: 'HistoricalDepotValue', id: string, calendarDate: any, twr1yAbs?: number | null, twr1yRel?: number | null, twrSinceInceptionAbs?: number | null, twrSinceInceptionRel?: number | null, twrYtdAbs?: number | null, twrYtdRel?: number | null }>, portfolioBreakdown: Array<{ __typename?: 'PortfolioBreakdown', id: string, percentage: number, assets: { __typename?: 'PortfolioAssetConnection', nodes: Array<{ __typename?: 'PortfolioAsset', id: string, name: string, percentage: number }> }, assetClass: { __typename?: 'AssetClass', id: string, name: string, chartColors: Array<string> } }> } | null };

export type GetDepotValueQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepotValueQuery = { __typename?: 'Query', depot?: { __typename?: 'Depot', value: number } | null };

export type GetModalTransactionsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetModalTransactionsQuery = { __typename?: 'Query', depot?: { __typename?: 'Depot', id: string, netInvestmentSinceInceptionDeposits?: number | null, netInvestmentSinceInceptionWithdrawals?: number | null, transactions: { __typename?: 'TransactionConnection', edges: Array<{ __typename?: 'TransactionEdge', node?: { __typename?: 'Transaction', id: string, happenedOn: any, transactionType: TransactionTransaction, description: string, amount: number } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type GetViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', email: string, givenName?: string | null, familyName?: string | null, name: string } };

export type RequestWithdrawalMutationVariables = Exact<{
  id: Scalars['ID'];
  value: Scalars['Float'];
}>;


export type RequestWithdrawalMutation = { __typename?: 'Mutation', requestWithdrawal?: { __typename?: 'RequestWithdrawalPayload', withdrawal: { __typename?: 'PendingTransaction', value: number }, depot: { __typename?: 'Depot', pendingTransactions: { __typename?: 'PendingTransactionConnection', nodes: Array<{ __typename?: 'PendingTransaction', value: number, transactionType: PendingTransactionTransaction }> } } } | null };


export const GetNavbarDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNavbarData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetNavbarDataQuery, GetNavbarDataQueryVariables>;
export const GetHomeDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHomeData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"twrSinceInceptionAbs"}},{"kind":"Field","name":{"kind":"Name","value":"twrSinceInceptionRel"}},{"kind":"Field","name":{"kind":"Name","value":"twrYtdAbs"}},{"kind":"Field","name":{"kind":"Name","value":"twrYtdRel"}},{"kind":"Field","name":{"kind":"Name","value":"twr1yAbs"}},{"kind":"Field","name":{"kind":"Name","value":"twr1yRel"}},{"kind":"Field","name":{"kind":"Name","value":"netInvestmentSinceInception"}},{"kind":"Field","name":{"kind":"Name","value":"historicalDepotValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"calendarDate"}},{"kind":"Field","name":{"kind":"Name","value":"twrRelPerc"}},{"kind":"Field","name":{"kind":"Name","value":"twr1yAbs"}},{"kind":"Field","name":{"kind":"Name","value":"twr1yRel"}},{"kind":"Field","name":{"kind":"Name","value":"twrSinceInceptionAbs"}},{"kind":"Field","name":{"kind":"Name","value":"twrSinceInceptionRel"}},{"kind":"Field","name":{"kind":"Name","value":"twrYtdAbs"}},{"kind":"Field","name":{"kind":"Name","value":"twrYtdRel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearingIban"}}]}}]}}]} as unknown as DocumentNode<GetHomeDataQuery, GetHomeDataQueryVariables>;
export const GetMonthlyDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMonthlyDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"monthlySummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"happenedOn"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMonthlyDetailsQuery, GetMonthlyDetailsQueryVariables>;
export const GetPortfolioDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPortfolioData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolioBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chartColors"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPortfolioDataQuery, GetPortfolioDataQueryVariables>;
export const GetDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentsQuery, GetDocumentsQueryVariables>;
export const GetProfileDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfileData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearingIban"}},{"kind":"Field","name":{"kind":"Name","value":"strategy"}},{"kind":"Field","name":{"kind":"Name","value":"depotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetProfileDataQuery, GetProfileDataQueryVariables>;
export const GetTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"monthlySummaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"breakdowns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chartColors"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"happenedOn"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTransactionsQuery, GetTransactionsQueryVariables>;
export const RequestDepositDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestDeposit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestDeposit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pendingDeposits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RequestDepositMutation, RequestDepositMutationVariables>;
export const GetDepotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDepot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"clearingIban"}},{"kind":"Field","name":{"kind":"Name","value":"strategy"}},{"kind":"Field","name":{"kind":"Name","value":"depotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"twrSinceInceptionAbs"}},{"kind":"Field","name":{"kind":"Name","value":"twrSinceInceptionRel"}},{"kind":"Field","name":{"kind":"Name","value":"twr1yAbs"}},{"kind":"Field","name":{"kind":"Name","value":"twr1yRel"}},{"kind":"Field","name":{"kind":"Name","value":"twrYtdAbs"}},{"kind":"Field","name":{"kind":"Name","value":"twrYtdRel"}},{"kind":"Field","name":{"kind":"Name","value":"netInvestmentSinceInception"}},{"kind":"Field","name":{"kind":"Name","value":"historicalDepotValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"calendarDate"}},{"kind":"Field","name":{"kind":"Name","value":"twr1yAbs"}},{"kind":"Field","name":{"kind":"Name","value":"twr1yRel"}},{"kind":"Field","name":{"kind":"Name","value":"twrSinceInceptionAbs"}},{"kind":"Field","name":{"kind":"Name","value":"twrSinceInceptionRel"}},{"kind":"Field","name":{"kind":"Name","value":"twrYtdAbs"}},{"kind":"Field","name":{"kind":"Name","value":"twrYtdRel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portfolioBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chartColors"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDepotQuery, GetDepotQueryVariables>;
export const GetDepotValueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDepotValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetDepotValueQuery, GetDepotValueQueryVariables>;
export const GetModalTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetModalTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"netInvestmentSinceInceptionDeposits"}},{"kind":"Field","name":{"kind":"Name","value":"netInvestmentSinceInceptionWithdrawals"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"types"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"deposit"},{"kind":"EnumValue","value":"withdrawal"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"happenedOn"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetModalTransactionsQuery, GetModalTransactionsQueryVariables>;
export const GetViewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetViewerQuery, GetViewerQueryVariables>;
export const RequestWithdrawalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestWithdrawal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestWithdrawal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RequestWithdrawalMutation, RequestWithdrawalMutationVariables>;